// Sandbox
//exports.stripePublishableKey = 'pk_test_rhNH46JCLgFAuf3j0Spor2R8';
exports.stripePublishableKey = 'pk_live_gsJsmWqh04wyiBNiSvNTna68';
